import { post } from '@/http/request.js'

// 可用余额
export const yacolScQueryBalance = (data) => post('yacol/sc-query-balance', data, 'zq_shop')

// 账户余额记录
export const ystSubAccountBalanceRecord = (data) => post('yst/sub-account-balance-record', data, 'zq_shop')

// 通过手机号获取创业天下用户信息
export const getUserInfo = (data) => post('user/get-user-idcard', data, 'cytx')

// 开通雅酷账户
export const yacolScRegisterMerchant = (data) => post('yacol/sc-register-merchant', data, 'zq_shop')

// 雅酷-支持的银行列表
export const yacolSupportBankList = (data) => post('yacol/support-bank-list', data, 'zq_shop')

// 雅酷-解除绑定银行卡
export const yacolUnBindBankCard = (data) => post('yacol/free-bind-bank-card', data, 'zq_shop')

// 重置 提现 配置
export const resetWithdrawalConfig = (data) => post('home/config', data, 'zq_shop')

// 雅酷-余额记录
export const yacolScBalanceRecord = (data) => post('yacol/sc-balance-record', data, 'zq_shop')

// 雅酷-查询绑定的银行卡
export const yacolQueryBankCard = (data) => post('yacol/query-bank-card', data, 'zq_shop')

// 雅酷-提现
export const yacolScWithdraw = (data) => post('yacol/sc-withdraw', data, 'zq_shop')

// 雅酷-绑定银行卡发送短信
export const yacolBindBankCardSms = (data) => post('yacol/bind-bank-card-sms', data, 'zq_shop')

// 雅酷-绑定银行卡
export const yacolBindBankCard = (data) => post('yacol/bind-bank-card', data, 'zq_shop')

// 雅酷-绑定银行卡-短信验证
export const yacolBindBankCardAdvance = (data) => post('yacol/bind-bank-card-advance', data, 'zq_shop')

// 雅酷-绑定银行卡-充值
export const yacolBindBankCardRecharge = (data) => post('yacol/bind-bank-card-recharge', data, 'zq_shop')

// 雅酷-绑定银行卡-充值-短信验证
export const yacolBindBankCardRechargeAdvance = (data) => post('yacol/bind-bank-card-recharge-advance', data, 'zq_shop')

// 雅酷-绑定银行卡-充值-短信验证
export const yacolBindBankCardPaySms = (data) => post('yacol/bind-bank-card-pay-sms', data, 'zq_shop')

// 雅酷-绑定银行卡-充值-支付
export const yacolBindBankCardPayAdvance = (data) => post('yacol/bind-bank-card-pay-advance', data, 'zq_shop')

// 雅酷支付宝支付
export const yacolScJsPay = (data) => post('yacol/sc-js-pay', data, 'zq_shop')

// 雅酷-订单详情
export const yacolOrderTempGet = (data) => post('yacol/order-temp-get', data, 'zq_shop')

// 用户信息缓存（需要在全局锁期间跳过锁）
export const fastLogin = (param) => post('partner/login-zq', param, 'cytx', 'bypass')

// 用户信息（需要在全局锁期间跳过锁）
export const getCytxuserInfo = (param) => post('partner/user-info', param, 'cytx', 'bypass')



// 零钱明细
export const getBalanceList = (data, loading) => post('wallet/balance-detail', data, loading)

// 用户是否完善资料
export const perfectInfo = (data, loading) => post('wallet/is-perfect-info', data, loading)

// 华云付-银行列表
export const huaBankList = (data, loading) => post('wallet/pay-bank', data, loading)

// 完善信息-个人信息展示
export const showPerfectInfo = (data, loading) => post('wallet/perfect-info', data, loading)

// 完善信息-提交
export const submitPerfectInfo = (data, loading) => post('wallet/perfect-info-submit', data, loading)

// 开户提交验证
export const addBankValidate = (data, loading) => post('wallet/add_bank_validate', data, loading)

// 充值页面
export const getAddBankValidate = (data, loading) => post('wallet/recharge_page', data, loading)

// 提现页面-返回绑定的银行卡
export const returnBankCard = (data, loading) => post('wallet/return-bank-card', data, loading)

// 更换提现银行卡
export const replaceBankCard = (data, loading) => post('wallet/replace-bank-card', data, loading)

// 提现
export const withdraw = (data, loading) => post('wallet/withdraw', data, loading)

// 发送短信
export const sendSms = (data, loading) => post('wallet/send-sms', data, loading)

// 余额转账-创建订单
export const createPay = (data, loading) => post('wallet/create-pay', data, loading)

// 余额转账-确认转账
export const confirmPay = (data, loading) => post('wallet/pay-confirm', data, loading)

// 余额转账-确认转账
export const voucherPay = (data, loading) => post('wallet/voucher-pay', data, loading)

// 钱包认证信息是否被占用
export const isPerfectInfo = (data, loading) => post('wallet/is-perfect-info', data, loading)

// 获取省市区
export const PayArea = (data, loading) => post('wallet/pay-area', data, loading)

// 渠道申请绑卡
export const addBankApply = (data, loading) => post('wallet/add-bank-apply', data, loading)

// 提现手续费计算
export const commission = (data, loading) => post('wallet/withdraw-fee', data, loading)

// 新增渠道银行卡
export const addNewBankApply = (data, loading) => post('wallet/bank-card-insert', data, loading)

// 查询渠道银行卡列表
export const selectBankList = (data, loading) => post('wallet/bank-card-select-list', data, loading)

// 切换默认卡
export const updateCard = (data, loading) => post('wallet/update-select-card', data, loading)




